import React, { Component } from "react";
import { BrowserRouter, Route, Routes, useLocation} from "react-router-dom";
import Home from "./components/Home.tsx";
import About from "./components/About.tsx"
import Blog from "./components/Blog.tsx"
import Projects from "./components/Projects.tsx"
import Post from "./components/Post.tsx"
import TaxKnight from "./components/TaxKnight.tsx";
import BevyGraphs from "./components/BevyGraphs.tsx";

export default function App() {
  return (
    <BrowserRouter>
      <div className="App flex-col h-screen">
        <div className="c">
            <Routes>
              <Route path="/" element={<Home/>}/>
              <Route path="/home" element={<Home/>}/>
              <Route path="/projects" element={<Projects/>}/>
              <Route path="/blog" element={<Blog/>}/>
              <Route path="/about" element={<About/>}/>
              <Route path="/projects/:post_id" element={<Post/>}/>
              <Route path="/projects/taxknight" element={<TaxKnight/>}/>      
              <Route path="/projects/bevy_graphs" element={<BevyGraphs/>}/>
            </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
} 

